<template>
  <div class="transition-all duration-100 ease-linear custom-left">
    <div class="flex xl:flex-row flex-col justify-between p-[16px]">
      <h2 class="text-[24px] font-semibold text-white">Customer list</h2>
      <div class="table-actions xl:flex-row flex-col xl:items-center items-end flex" v-if="!iscomponentactive">
        <div v-if="can_export_customers" class="flex mb-2">
          <button @click="exportCustomers" class="bg-theme-green text-white px-4 py-2 rounded-md uppercase disabled:opacity-50">Export</button>
        </div>
      </div>
    </div>

    <div class="table w-full mt-6 px-2 pb-4">
      <new-table-lite
        class="min-h-[480px] admin-table"
        :is-slot-mode='true'
        :columns="columns"
        :rows="table.rows"
        :is-loading="table.loading"
        :rowClasses="customRowClass"
        :total="table.totalRecordCount"
        :sortable="table.sortable"
        :page-size='table.pagesize'
        @do-search="doSearch"
        :pageOptions='table.pageOptions'
        :has-checkbox="false"
        :checked-return-type="'id'"
        :is-hide-paging="false"
        :pageSizeChangeLabel="'pageSizeChangeLabel'"
        :messages="{
          pagingInfo: 'Total: {2}',
          pageSizeChangeLabel: 'Items per Page',
          gotoPageLabel: '',
          noDataAvailable: 'No records found!',
        }"
        :page="table.page"
        @row-clicked="selectedRow"
      >
        <!-- filter -->
        <template v-slot:tableCaption>
          <div class="grid grid-cols-12 m-2 gap-2 z-20">
            <div :class="iscomponentactive?'col-span-8':'col-span-4'">
              <input placeholder="Name" name="search" v-model="filters.search" class="productName w-full rounded h-[42px] bg-theme-modalbg ring-0 outline-0 px-2 mb-1 text-white border border-transparent focus:border focus:border-theme-green">
            </div>
            <div :class="iscomponentactive?'hidden':'col-span-4'">
                <Select v-model="filters.locationId" selectClass="w-full rounded bg-theme-modalbg mb-1 text-white border border-transparent focus:border focus:border-theme-green pr-2 h-[42px]" optionClass="top-[42px] w-full" placeholder="Primary location" :options="getLocationOptions" />
            </div>
            <div :class="iscomponentactive?'hidden':'col-span-3'">
              <Select v-model="filters.verification" selectClass="w-full rounded bg-theme-modalbg mb-1 text-white border border-transparent focus:border focus:border-theme-green pr-2 h-[42px]" optionClass="top-[42px] w-full" placeholder="Verified status" :options="verifiedOptions" />
            </div>
            <div :class="iscomponentactive?'hidden':'col-span-1 flex items-center justify-center'">
              <button @click="resetFilters" class="text-theme-green">Reset all</button>
            </div>
          </div>
        </template>
        <!-- content -->
        <template v-slot:memberSince="data">
          {{ data.value.memberSince ? getReadAbleDate(data.value.memberSince) : getReadAbleDate(data.value.createdAt) }}
        </template>
        
      </new-table-lite>
    </div>
  </div>
</template>

<script>
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import NewTableLite from '@/components/table/tableLite.vue'
import Select from '@/components/form/Select.vue'
import Env from '@/env';
import Datepicker from 'vue3-datepicker'
import UserCustomerApis from '@/controllers/UserCustomerApis';
import moment from 'moment';
import debounce from 'lodash/debounce'
import writeXlsxFile from 'write-excel-file';
import Helpers from '@/helpers';

export default defineComponent({
  name: 'MembershipCustomerList',
  components: {
    NewTableLite,
    Select,
    Datepicker
  },
  props: {
    iscomponentactive: {
      type: Boolean,
      required: false,
    },
    selectedCallback: {
      type: Function,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
    changeComponent: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const filters = ref({
      locationId: null,
      verification: null,
      casl_users: false,
      search: '',
      since: '',//new Date('2000-01-01'),
    });
    const verifiedOptions = ref([
      {
        name: "All",
        id: "",
      },
      {
        name: "Verified email",
        id: "email",
      },
      {
        name: "Verified phone number",
        id: "phone",
      },
      {
        name: "Fully verified",
        id: "fully_verified",
      },
    ])
    const locationId = ref(null)
    const activeItem = ref({});
    const loading = ref(false);
    const columnsMain = ref([
      {
        label: "First Name",
        field: "firstName",
        sortable: true,
      },
      {
        label: "Last Name",
        field: "lastName",
        sortable: true,
      },
      {
        label: "Email",
        field: "email",
        sortable: true,
      },
       {
        label: "Phone",
        field: "phone",
        sortable: true,
      },
       {
        label: "Total Spent",
        field: "totalOrderValue",
        sortable: true,
      },
      {
        label: "Membership Balance",
        field: "points",
        sortable: true,
      },
      {
        label: "Member Since",
        field: "memberSince",
        sortable: true,
      },
    ]);

    const table = ref({
      loading: false,
      rows: [],
      totalRecordCount: 0,
      count: 0,
      sortable: {
        order: "",
        sort: "",
      },
      pagesize: Env.defaultPageSize,
      pageOptions: Env.pageList,
      page: 1,
    });

    return  {
      table,
      columnsMain,
      verifiedOptions,
      locationId,
      activeItem,
      loading,
      filters,
      snackbar,
    };
  },

  created() {
    this.skipFilterWatch = false;
    this.debouncedSearch = debounce(function(val){
      if(val.length>=3){
        this.doSearch(1, this.table.pagesize, this.table.sortable.order, this.table.sortable.sort)
      }else if(val.length==0){
        this.doSearch(0, this.table.pagesize, this.table.sortable.order, this.table.sortable.sort)
      }
    }, 900);
  },

  async mounted() {
    this.loading = true;
    await this.fetchList(this.table.page);
    this.loading = false;
    this.emitter.on("refresh-loyalty-user-list", data => {
      this.fetchList(this.table.page);
    });
    this.emitter.on("update-loyalty-user", (data) => {
      let getTheIndexOfUser =  this._lodash.findIndex(this.table.rows, (user) => user.id === data.id);
      if(getTheIndexOfUser >= 0) {
        this.table.rows[getTheIndexOfUser] = data
      }
    });
  },

  beforeDestroy() {
   this.debouncedSearch.cancel();
   this.emitter.off('refresh-loyalty-user-list', () => {})
  },

  watch: {
    'filters.search'(val){
      if(this.skipFilterWatch) return;
      this.debouncedSearch(val);
    },
    'filters.verification': function(){
      if(this.skipFilterWatch) return;
      this.doSearch(0, this.table.pagesize, this.table.sortable.order, this.table.sortable.sort)
    },
    'filters.locationId': function(){
      if(this.skipFilterWatch) return;
      this.doSearch(0, this.table.pagesize, this.table.sortable.order, this.table.sortable.sort)
    }
  },

  computed: {
    /**
     * Manage export permission
     */
      can_export_customers() {
        return Helpers.getMyPermission('can_export_customer_list')
    },
    ...mapGetters({
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_locations: 'location/list',
    }),

    /**
     * Compute columns
     */
    columns() {
      if(this.iscomponentactive){
        let removeFields= ['createdAt', 'total_spent', 'points', 'phone'];
        return this.columnsMain.filter(item => {
            if( removeFields.indexOf(item.field) == -1 ) {
              return item;
            }
        })
      }
      return this.columnsMain;
    },
    getLocationOptions(){
      let initialOptions = {
        name: "All",
        id: "",
      }
      
      let allLocationOptions = this.vg_locations.map(location => ({
        name: location.name,
        id: location.id,
      }));
      console.log([initialOptions, ...allLocationOptions])
      return [initialOptions, ...allLocationOptions];
    },
  },

  methods: {
    resetFilters(){
      this.skipFilterWatch = true;
      this.debouncedSearch.cancel();
      this.filters.locationId = null;
      this.filters.verification = null;
      this.filters.search = '';
      this.doSearch(0, this.table.pagesize, this.table.sortable.order, this.table.sortable.sort);
      this.$nextTick(() => {
        this.skipFilterWatch = false;
      });
    },
    /**
     * Fetch list
     */
    async fetchList(page) {
      this.table.loading = true;
      let params = await this.getCustomerListParams();
      let res = await UserCustomerApis.getBusinessUsers(params);
      this.table.rows = (res.status == 200) ? res.data.payload.users  : [];
      this.table.totalRecordCount = (res.status == 200) ? res.data.payload.totalRecords : 0
      this.table.loading = false;
    },

     /**
     * Search now
     */
     doSearch(offset, limit, order, sort) {
      this.table.loading = true;
      this.table.sortable.order = order
      this.table.sortable.sort = sort
      this.table.pagesize = limit;
      let page = parseInt(offset/limit)+1
      this.table.page = page
      this.table.loading = false;
      this.fetchList(page);
    },

    async getCustomerListParams(exports=false) {
      let params =  {
        businessId: this.vg_selectedBusiness.id,
        locationId: this.locationId,
        search: this.filters.search,
        primaryLocationId: this.filters.locationId,
        verification: this.filters.verification,
        limit: this.table.pagesize,
        page: this.table.page,
        sort: this.table.sortable.order,    // api and table lite have opposite
        order: this.table.sortable.sort     // api and table lite have opposite
      }
      if(exports) {
        params.noPage = true
      }
      return params
    },

    async exportCustomers() {
      if (!this.vg_selectedBusiness?.id) return

      try {
        this.va_spinner(true)
        const dateStr = moment().format('YYYY-MM-DD')
        let params = await this.getCustomerListParams(true);
        const res = await UserCustomerApis.getBusinessUsers(params)
        if(res.status === 200){
          const payload = res.data.payload
          const rows = payload?.users || payload?.data || (Array.isArray(payload) ? payload : [])
          await this.downloadCustomerExcel(rows, `customer-export-${dateStr}.xlsx`)
        }
        this.snackbar.add({
          type: 'info',
          text: res.status === 200 ? 'File downloaded' : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      } catch (err) {
        console.log(err)
        this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      } finally {
        this.exporting = false
        this.va_spinner(false)
      }
    },

    
    /**
     * Select the item
     */
    selectedRow(item) {
      // Select unselect the item
      if(this.activeItem.id) {
        let oldactive = document.getElementsByClassName('thisid_'+this.activeItem.id);
        if(oldactive.length > 0){
          oldactive[0].classList.remove("active-row");
        }
      }
      this.activeItem = item;
      let newActive = document.getElementsByClassName('thisid_' + this.activeItem.id);
      if(newActive.length > 0){
        newActive[0].classList.add("active-row");
      }
      this.selectedCallback(item);
    },

    /**
     * Create custom class on tr for active colors
     */
    customRowClass(item) {
      return 'thisid_' + item.id;
    },
    formatVerifiedStatus(value) {
      return value ? 'Verified' : 'Unverified'
    },
    joinTaxExempt(array) {
      let data = array?.map(item => item.name)?.join(', ')
      return data || ''
    },
    getCustomerExportSchema() {
      return [
        {
          column: 'First name',
          type: String,
          value: row => row.firstName || '',
        },
        {
          column: 'Last name',
          type: String,
          value: row => row.lastName || '',
        },
        {
          column: 'Email',
          type: String,
          value: row => row.email || '',
        },
        {
          column: 'Email verification status',
          type: String,
          value: row => this.formatVerifiedStatus(row.emailVerificationStatus),
        },
        {
          column: 'Phone number',
          type: String,
          value: row => row.phone ? String(row.phone) : '',
        },
        {
          column: 'Phone verification status',
          type: String,
          value: row => this.formatVerifiedStatus(row.phoneVerificationStatus),
        },
        {
          column: 'Primary location',
          type: String,
          value: row => row.primaryLocationRecord?.name || '',
        },
        {
          column: 'Birthday',
          type: String,
          value: row => row.dob,
        },
        {
          column: 'Total Spent',
          type: Number,
          value: row => row.totalOrderValue || 0,
        },
        {
          column: 'Point amount',
          type: Number,
          value: row => row.points || 0,
        },
        {
          column: 'Membership ID',
          type: Number,
          value: row => row.loyaltyNumber || null,
        },
        {
          column: 'Member Since',
          type: String,
          value: row => row.memberSince ? this.getReadAbleDate(row.memberSince) : '',
        },
        {
          column: 'Casl-opt in',
          type: String,
          value: row => String(row.marketing),
        },
        {
          column: 'Address',
          type: String,
          value: row => row.address || '',
        },
        {
          column: 'city',
          type: String,
          value: row => row.city || '',
        },
        {
          column: 'province',
          type: String,
          value: row => row.province || '',
        },
        {
          column: 'postal code',
          type: String,
          value: row => row.postalCode || '',
        },
        {
          column: 'Notes',
          type: String,
          value: row => row.notes || '',
        },
        {
          column: 'Status ID number',
          type: String,
          value: row => row.idNumber || '',
        },
        // {
        //   column: 'Customer group',
        //   type: String,
        //   value: row => this.formatJoinedList(row.customerGroups || row.groups || row.customerGroup),
        // },
        {
          column: 'Tax exempt',
          type: String,
          value: row => this.joinTaxExempt(row.taxExemption),
        },
      ]
    },
    async downloadCustomerExcel(rows, fileName) {
      const schema = this.getCustomerExportSchema()
      const xlBlob = await writeXlsxFile(rows, { schema })
      const url = URL.createObjectURL(xlBlob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', fileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    
    /**
     * GEt readable date
     */
    getReadAbleDate(dateString) {
     return dateString ? moment(dateString).format('YYYY-MM-DD') : '';
    },

    customSearch() {
      this.table.page = 1;
      this.fetchList(this.table.page);
    },


    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })

  }
});
</script>
<style>
  .customer-list .admin-table tbody{
    display: block;
    /* height:calc(100vh - 320px); */
    /* overflow-y: scroll; */
  }
  .customer-list .admin-table thead tr,
  .customer-list .admin-table tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
</style>

